import { createFileRoute } from "@tanstack/react-router";
import { AuthLayout } from "#app/components/auth/auth-layout";
import { LoginForm } from "#app/components/auth/login-form";

function LoginScreen() {
  return (
    <AuthLayout
      centered
      heading="Sign in to your account"
      subheading="Enter your credentials to continue"
      footerText="Don't have an account?"
      footerLinkText="Sign up"
      footerLinkHref="/register"
    >
      <LoginForm />
    </AuthLayout>
  );
}

export const Route = createFileRoute("/(auth)/login")({
  component: LoginScreen,
});
